/* Der Schwarze Kapitän – Mock-Dienst (Spielstand, Stufen, Mehrheiten, Ladung, Bohnen).
   Everything here is simulated in the browser (localStorage). No network calls. */
(function (global) {
  'use strict';
  var D = global.KAPITAEN_DATEN;
  var KEY = 'kapitaen-demo-v2';

  var STUFEN = [
    { id: 'vorab', kurz: 'Vorab', datum: 'bis 29.10.', zustand: 'A', etappe: 0, look: 'hell' },
    { id: 'e1', kurz: 'E1', datum: 'Fr 30.10.', zustand: 'B', etappe: 1, look: 'hell' },
    { id: 'e2', kurz: 'E2', datum: 'So 1.11.', zustand: 'B', etappe: 2, look: 'kopf' },
    { id: 'e3', kurz: 'E3', datum: 'Mi 4.11.', zustand: 'B', etappe: 3, look: 'kopf' },
    { id: 'e4', kurz: 'E4', datum: 'So 8.11.', zustand: 'B', etappe: 4, look: 'kopf' },
    { id: 'e5', kurz: 'E5', datum: 'Mi 11.11.', zustand: 'B', etappe: 5, look: 'kopf' },
    { id: 'e6', kurz: 'E6', datum: 'So 15.11.', zustand: 'B', etappe: 6, look: 'kopf' },
    { id: 'e7', kurz: 'E7', datum: 'Mi 18.11.', zustand: 'B', etappe: 7, look: 'kopf' },
    { id: 'e8', kurz: 'E8', datum: 'So 22.11.', zustand: 'B', etappe: 8, look: 'kopf' },
    { id: 'steuermann', kurz: 'Steuermann', datum: 'So 22.11., 20 Uhr', zustand: 'B', etappe: 8, steuermann: true, look: 'kopf' },
    { id: 'bw1', kurz: 'BW1', datum: 'Mo 23.11.', zustand: 'C', etappe: 9, tag: 1, look: 'dunkel' },
    { id: 'bw2', kurz: 'BW2', datum: 'Di 24.11.', zustand: 'C', etappe: 9, tag: 2, look: 'dunkel' },
    { id: 'bw3', kurz: 'BW3', datum: 'Mi 25.11.', zustand: 'C', etappe: 9, tag: 3, look: 'dunkel' },
    { id: 'bw4', kurz: 'BW4', datum: 'Do 26.11.', zustand: 'C', etappe: 9, tag: 4, look: 'dunkel' },
    { id: 'bw5', kurz: 'BW5', datum: 'Fr 27.11.', zustand: 'C', etappe: 9, tag: 5, look: 'dunkel' },
    { id: 'bw6', kurz: 'BW6', datum: 'Sa 28.11.', zustand: 'C', etappe: 9, tag: 6, look: 'dunkel' },
    { id: 'signal', kurz: 'Signal', datum: 'So 29.11.', zustand: 'D', etappe: 9, look: 'dunkel' },
    { id: 'finale', kurz: 'Finale', datum: 'Mo 30.11.', zustand: 'E', etappe: 9, look: 'finale' },
    { id: 'epilog', kurz: 'Epilog', datum: 'ab Di 1.12.', zustand: 'E', etappe: 9, epilog: true, look: 'finale' }
  ];
  var DATUM_STUFE = { '2026-10-30': 'e1', '2026-11-01': 'e2', '2026-11-04': 'e3', '2026-11-08': 'e4', '2026-11-11': 'e5', '2026-11-15': 'e6', '2026-11-18': 'e7', '2026-11-22': 'e8', '2026-11-23': 'bw1', '2026-11-24': 'bw2', '2026-11-25': 'bw3', '2026-11-26': 'bw4', '2026-11-27': 'bw5', '2026-11-28': 'bw6', '2026-11-29': 'signal', '2026-11-30': 'finale', '2026-12-01': 'epilog' };
  var NAECHSTE_POST = ['Fr 30.10.', 'So 1.11.', 'Mi 4.11.', 'So 8.11.', 'Mi 11.11.', 'So 15.11.', 'Mi 18.11.', 'So 22.11.', 'Mo 23.11.'];

  /* A plausible default course: rich in variants, ends with 5 sacks (10 %). */
  var STANDARD_PFADE = { 1: 'C', 2: 'A', 3: 'C', 4: 'A', 5: 'A', 6: 'C', 7: 'B', 8: 'D', signal: 'ueberlaufen' };

  function neu() {
    return { stufe: 'vorab', token: false, name: 'Jette', pfade: Object.assign({}, STANDARD_PFADE), stimmen: {}, antworten: {}, signal: null, angeheuert: false, doi: false, bohnenVorher: 0, a: null };
  }
  var S = laden();

  function laden() {
    try { var raw = global.localStorage.getItem(KEY); if (raw) return Object.assign(neu(), JSON.parse(raw)); } catch (e) { /* private mode */ }
    return neu();
  }
  function sichern() { try { global.localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) { /* ignore */ } }

  function stufeIndex(x) {
    if (x === null || x === undefined || x === '') return 0;
    if (typeof x === 'number') return Math.max(0, Math.min(8, x));
    var s = String(x).trim().toLowerCase();
    if (DATUM_STUFE[s]) s = DATUM_STUFE[s];
    var alias = { a: 'vorab', b: 'e1', c: 'bw1', d: 'signal', e: 'finale', k0: 'vorab', 'etappe-1': 'e1', gekapert: 'bw1', blackweek: 'bw1', rueckeroberung: 'finale' };
    if (alias[s]) s = alias[s];
    var m = /^e(?:tappe)?\s*-?(\d)$/.exec(s);
    if (m) s = 'e' + m[1];
    m = /^(?:bw|tag)\s*-?(\d)$/.exec(s);
    if (m) s = 'bw' + m[1];
    if (/^\d$/.test(s)) s = 'e' + s;
    for (var i = 0; i < STUFEN.length; i++) if (STUFEN[i].id === s) return i;
    return 0;
  }
  function stufe() { return STUFEN[stufeIndex(S.stufe)]; }
  function etappe(n) { return D.etappen[n - 1]; }

  /* ---- Bedingungen: "E1=A", "E4=C&E5!=B", "LADUNG=0" (ctx.vor = etappe whose text is evaluated) ---- */
  function bedingung(str, ctx) {
    if (!str) return true;
    ctx = ctx || {};
    return String(str).split('&').every(function (teil) {
      var m = /^\s*(?:E(\d)|LADUNG)\s*(!=|=)\s*(\w+)\s*$/.exec(teil);
      if (!m) return false;
      var wert = m[1] ? pfad(+m[1]) : String(ladungNach(ctx.vor ? ctx.vor - 1 : aufgeloestBis()));
      var gleich = wert === m[3];
      return m[2] === '=' ? gleich : !gleich;
    });
  }
  /* Locks only reference earlier etappen, so this never recurses into n itself. */
  function gesperrt(n, opt) { return !!(opt && opt.gesperrt_wenn && bedingung(opt.gesperrt_wenn, { vor: n })); }

  /* Majority decision of the Schiffsrat for etappe n (validated against locks). */
  function pfad(n) {
    var e = etappe(n); if (!e) return null;
    var want = S.pfade[n] || STANDARD_PFADE[n];
    var opts = e.schiffsrat.optionen;
    var o = opts.filter(function (x) { return x.key === want; })[0];
    if (o && !gesperrt(n, o)) return o.key;
    for (var i = 0; i < opts.length; i++) if (!gesperrt(n, opts[i])) return opts[i].key;
    return opts[0].key;
  }
  function option(n, key) { return etappe(n).schiffsrat.optionen.filter(function (o) { return o.key === key; })[0]; }

  /* ---- Ladung ---- */
  function ladungNach(k) {
    var l = 0;
    for (var n = 1; n <= Math.min(k, 8); n++) {
      var o = option(n, pfad(n));
      if (!o) continue;
      if (o.sack) l += 1;
      if (o.sack_verlust) l = Math.max(0, l - 1);
    }
    return Math.min(6, l); // the hold takes six sacks; a seventh full haul is capped (QA F11, documented in README)
  }
  function aufgeloestBis() { var st = stufe(); return st.zustand === 'A' ? 0 : (st.zustand === 'B' ? st.etappe - 1 : 8); }
  function ladung() { return ladungNach(aufgeloestBis()); }
  function pct(l) { if (l === undefined) l = ladung(); return l >= 6 ? 15 : (l >= 3 ? 10 : 5); }

  /* ---- Bohnen ---- */
  function antworten(n) { return S.antworten[n] || {}; }
  /* index of the right option; null if the data carries no answers (js/daten.public.js) */
  function richtige(n, i) { var e = etappe(n), f = e && e.fragen[i]; return f && f.richtig !== undefined ? f.richtig : null; }
  function istRichtig(n, i) { var a = antworten(n), r = richtige(n, i); return a[i] === undefined || r === null ? null : a[i] === r; }
  function richtigIn(n) {
    var e = etappe(n); if (!e) return 0; var a = antworten(n), c = 0;
    e.fragen.forEach(function (f, i) { if (a[i] === f.richtig) c++; });
    return c;
  }
  /* beans that can come from earlier Etappen: 3 per Etappe before this one; on the Steuermann evening all 8 Etappen are done */
  function maxVorher() { var st = stufe(); return st.steuermann ? 24 : 3 * Math.max(0, Math.min(8, st.etappe) - 1); }
  function bohnen() {
    var st = stufe();
    var vorher = Math.min(S.bohnenVorher, st.zustand === 'B' ? maxVorher() : 24);
    return vorher + (st.zustand === 'B' && !st.steuermann ? richtigIn(st.etappe) : 0);
  }
  function bohnenMoeglich() { var st = stufe(); return st.zustand === 'B' && !st.steuermann ? Math.max(0, 8 - st.etappe) * 3 + (3 - Object.keys(antworten(st.etappe)).length) : 0; }

  /* ---- Mock distribution (deterministic, majority wins) ---- */
  function verteilung(n) {
    // Mock: the majority option always gets the clear maximum; locked options stay at 0.
    var e = etappe(n), mehr = pfad(n);
    var andere = e.schiffsrat.optionen.filter(function (o) { return !gesperrt(n, o) && o.key !== mehr; });
    var top = 44 + (n * 7) % 13;                       // 44–56 %
    var gew = [0.58, 0.28, 0.14].slice(0, andere.length), gs = gew.reduce(function (a, b) { return a + b; }, 0) || 1;
    var out = {}, summe = 0;
    andere.forEach(function (o, j) { out[o.key] = Math.round((100 - top) * gew[j] / gs); summe += out[o.key]; });
    out[mehr] = 100 - summe;
    var maxAnd = andere.reduce(function (m, o) { return Math.max(m, out[o.key]); }, 0);
    if (out[mehr] <= maxAnd && andere.length) { var k = andere[0].key, d = maxAnd - out[mehr] + 3; out[k] -= d; out[mehr] += d; }
    e.schiffsrat.optionen.forEach(function (o) { if (out[o.key] === undefined) out[o.key] = 0; });
    return out;
  }
  function signalVerteilung() { var w = S.pfade.signal || 'ueberlaufen'; return w === 'bleiben' ? { ueberlaufen: 41, bleiben: 59 } : { ueberlaufen: 68, bleiben: 32 }; }

  /* ---- Actions ---- */
  function setzeStufe(id) {
    var alt = stufe(), ni = stufeIndex(id), neuSt = STUFEN[ni];
    /* moving on adds the beans of the Etappe just left. The stored value is not cut down to what the new stage allows:
       bohnen() caps it per stage, so the Seesack set in the demo (e.g. 17 at E1) survives the journey to the Steuermann evening. */
    if (neuSt.zustand === 'B' && alt.zustand === 'B' && ni > stufeIndex(alt.id) && !alt.steuermann) {
      S.bohnenVorher = Math.min(24, S.bohnenVorher + richtigIn(alt.etappe));
    }
    S.stufe = neuSt.id; S.a = null; sichern();
  }
  function antworte(n, i, idx) {
    var a = S.antworten[n] = S.antworten[n] || {};
    if (a[i] !== undefined) return a[i] === etappe(n).fragen[i].richtig;
    a[i] = idx; sichern();
    return idx === etappe(n).fragen[i].richtig;
  }
  function stimme(n, key) { S.stimmen[n] = key; S.pfade[n] = key; sichern(); }
  function signalStimme(key) { S.signal = key; S.pfade.signal = key; sichern(); }
  function setzePfad(n, key) { S.pfade[n] = key; sichern(); }
  function setze(k, v) { S[k] = v; sichern(); }
  function zuruecksetzen() { var st = S.stufe, t = S.token; S = neu(); S.stufe = st; S.token = t; sichern(); }

  /* ---- Finale: Ausgang ---- */
  function ausgang() { return (S.pfade.signal || 'ueberlaufen') === 'bleiben' ? 'BLEIBEN' : 'UEBERLAUFEN'; }

  /* ---- URL ---- */
  function ausUrl() {
    var q = new URLSearchParams(global.location.search);
    if (q.get('reset') === '1') S = neu();
    var cfg = global.KAPITAEN_CONFIG;   // Shopify section setting stufe_override ("" = not set)
    if (cfg && cfg.stufe && !q.has('stufe')) S.stufe = STUFEN[stufeIndex(cfg.stufe)].id;
    if (q.has('stufe')) S.stufe = STUFEN[stufeIndex(q.get('stufe'))].id;
    if (q.has('token')) S.token = q.get('token') === '1';
    if (q.has('t')) S.token = true;
    if (q.has('name')) S.name = q.get('name').slice(0, 30);
    if (q.has('pfad')) q.get('pfad').toUpperCase().split('').forEach(function (k, i) { if (/[A-D]/.test(k) && i < 8) S.pfade[i + 1] = k; });
    if (q.has('signal')) S.pfade.signal = q.get('signal') === 'bleiben' ? 'bleiben' : 'ueberlaufen';
    if (q.has('bohnen')) S.bohnenVorher = Math.max(0, Math.min(24, parseInt(q.get('bohnen'), 10) || 0));
    if (q.has('a')) S.a = q.get('a').toUpperCase();
    if (q.has('angeheuert')) S.angeheuert = q.get('angeheuert') === '1';
    sichern();
  }
  function inUrl() {
    var q = new URLSearchParams(global.location.search);
    q.set('stufe', S.stufe); q.set('token', S.token ? '1' : '0');
    var p = ''; for (var n = 1; n <= 8; n++) p += pfad(n);
    q.set('pfad', p);
    if (S.pfade.signal === 'bleiben') q.set('signal', 'bleiben'); else q.delete('signal');
    q.set('bohnen', String(S.bohnenVorher));
    if (S.name && S.name !== 'Jette') q.set('name', S.name); else q.delete('name');
    if (S.angeheuert) q.set('angeheuert', '1'); else q.delete('angeheuert');
    q.delete('t'); q.delete('a'); q.delete('reset'); q.delete('leiste');
    try { global.history.replaceState(null, '', global.location.pathname + '?' + q.toString() + global.location.hash); } catch (e) { /* file:// in some browsers */ }
  }

  global.Spiel = {
    STUFEN: STUFEN, NAECHSTE_POST: NAECHSTE_POST, STANDARD_PFADE: STANDARD_PFADE, DATUM_STUFE: DATUM_STUFE,
    get stand() { return S; },
    stufe: stufe, stufeIndex: stufeIndex, etappe: etappe, option: option,
    pfad: pfad, bedingung: bedingung, gesperrt: gesperrt,
    ladung: ladung, ladungNach: ladungNach, pct: pct, aufgeloestBis: aufgeloestBis,
    bohnen: bohnen, bohnenMoeglich: bohnenMoeglich, maxVorher: maxVorher, antworten: antworten, richtigIn: richtigIn, richtige: richtige, istRichtig: istRichtig,
    verteilung: verteilung, signalVerteilung: signalVerteilung, ausgang: ausgang,
    setzeStufe: setzeStufe, antworte: antworte, stimme: stimme, signalStimme: signalStimme, setzePfad: setzePfad, setze: setze, zuruecksetzen: zuruecksetzen,
    ausUrl: ausUrl, inUrl: inUrl,
    codeMap: function () { return {}; }
  };
})(window);
